module.exports = __webpack_public_path__ + "img/Infobulle.8526d23c.svg";